import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import TermsOfService from '@/views/TermsOfService.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/privacy',
    name: 'Privacy Policy',
    component: PrivacyPolicy
  },
  {
    path: '/terms',
    name: 'Terms of Service',
    component: TermsOfService
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router